import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { Delete, Groups2Outlined } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import FlexBetween from "components/FlexBetween";
import moment from "moment";
import "moment/locale/id";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import { BASEURL } from "api/axiosInstance";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import { fetchListKaryawan } from "state/karyawanActions";
import {
  fetchAddPeringatan,
  fetchDeletePeringatan,
  fetchListPeringatan,
} from "state/peringatanAction";
import AddPeringatanModal from "components/Modals/AddPeringatanModal";
import SortableHeader from "components/SortableHeader";
moment.locale("id");

const Peringatan = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openAdd, setOpenAdd] = useState(false);
  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);

  const { status, message } = useSelector((state) => state.global);
  const { list_peringatan, pagination_peringatan } = useSelector(
    (state) => state.peringatan,
  );

  useEffect(() => {
    dispatch(fetchListPeringatan(page + 1, rowsPerPage));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  useEffect(() => {
    dispatch(fetchListKaryawan());
  }, [dispatch]);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListPeringatan(page + 1, rowsPerPage));
  };

  const handleSubmitPeringatan = (value) => {
    dispatch(fetchAddPeringatan(value));
  };

  const handleSelectedData = (id) => {
    let currentSelectedData = list_peringatan.find((item) => item.id === id);
    setSelectedData(currentSelectedData);
  };
  const handleDelete = () => {
    dispatch(fetchDeletePeringatan(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };

  const columnsPeringatan = [
    {
      name: "id", // Kolom UUID
      label: "ID",
      options: {
        display: false, // Disembunyikan dari tampilan tabel
      },
    },
    {
      name: "judul_peringatan",
      label: "Judul Peringatan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "id_karyawan",
      label: "ID Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "tanggal_berlaku",
      label: "Tanggal Berlaku",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => {
          return moment(value).format("DD MMMM YYYY");
        },
      },
    },
    {
      name: "tanggal_berakhir",
      label: "Tanggal Berakhir",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => {
          return moment(value).format("DD MMMM YYYY");
        },
      },
    },
    {
      name: "file_peringatan",
      label: "File Peringatan",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
          />
        ),
        customBodyRender: (value) => {
          const fileUrl = `${BASEURL}/files/${value}`;
          return (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "underline" }}
            >
              File Peringatan
            </a>
          );
        },
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0]; // Ambil ID dari kolom pertama
          return (
            <IconButton
              color="error"
              onClick={() => {
                setOpenKonfirmasi(true);
                handleSelectedData(id);
              }}
            >
              <Delete />
            </IconButton>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    responsive: "standard",
    serverSide: true,
    count: pagination_peringatan?.total ?? 0,
    page: page,
    rowsPerPageOptions: [25, 50, 75],
    rowsPerPage: rowsPerPage,
    onChangePage: (currentPage) => setPage(currentPage),
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
      setPage(0);
    },
  };

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header
          title="Peringatan"
          subtitle="Daftar Peringatan yang dibuat untuk karyawan."
        />

        <Box>
          <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light, // Tetap sama dengan warna awal
              },
            }}
            onClick={() => setOpenAdd(true)}
          >
            <Groups2Outlined sx={{ mr: "10px" }} />
            Tambah Peringatan
          </Button>
        </Box>
      </FlexBetween>
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_peringatan}
          columns={columnsPeringatan}
          options={options}
        />
        <AddPeringatanModal
          open={openAdd}
          onClose={() => setOpenAdd(false)}
          onSubmit={(value) => handleSubmitPeringatan(value)}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={"Hapus"}
          subtitleType={"Menghapus"}
          dataWillProses={
            selectedData?.judul_peringatan + " - " + selectedData?.id_karyawan
          }
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => handleDelete()}
        />
      </Box>
    </Box>
  );
};

export default Peringatan;
